import { render, staticRenderFns } from "./saleMangerPerson.vue?vue&type=template&id=742e2258&scoped=true&"
import script from "./saleMangerPerson.vue?vue&type=script&lang=js&"
export * from "./saleMangerPerson.vue?vue&type=script&lang=js&"
import style0 from "./saleMangerPerson.vue?vue&type=style&index=0&id=742e2258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742e2258",
  null
  
)

export default component.exports